import { useState } from 'react';

const usePDFStepper = () => {
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const goForward = () => {
    if (currentPage === totalPages) return;
    setCurrentPage(currentPage + 1);
  };

  const goPrevious = () => {
    if (currentPage === 1) return;
    setCurrentPage(currentPage - 1);
  };

  return {
    isLoading: totalPages === 0,
    currentPage,
    totalPages,
    setTotalPages,
    goForward,
    goPrevious,
  };
};

export default usePDFStepper;
